import styles from "./participation.module.scss";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Button, List } from "antd";
import { _adr } from "../../../../address";
import { complexDigitToman } from "../../../../tools/tools";
import { useTenders } from "../../../../tools/api";
import { useEffect, useState } from "react";
import Loading from "../../../../components/loader/loading";

const Participation = () => {
  const { queryCurrentUserBids } = useTenders();
  const nav = useNavigate();

  const [isLoadingList, setIsLoadingList] = useState(true);

  const [bTable, setBTable] = useState([]);
  //state current page show Records
  const [currentPage, setCurrentPage] = useState(0);
  // state totalRecord
  const [totalRecord, setTotalRecord] = useState(0);

  const Holder_Button = styled.div`
    margin-top: 0 !important;
  `;

  useEffect(() => {
    const initialData = async () => {
      try {
        setIsLoadingList(true);
        const payload = {
          searchconfigmodel: {
            sort: "",
            filter: "",
            entriesperpage: 10,
            page: currentPage === 0 ? 0 : currentPage - 1,
            totalrowcount: 0,
          },
          auctionstatus: [1],
        };
        const response = await queryCurrentUserBids(payload);
        if (!response.HasError) {
          setBTable(response?.Result);
          setTotalRecord(response?.searchconfigmodel?.totalrowcount);
        }
        setIsLoadingList(false);
      } catch (error) {
        console.error(error);
        setIsLoadingList(false);
      }
    };
    initialData();
  }, [currentPage]);

  const switchTagBag = (type = 0) => {
    switch (type) {
      case 0:
        return "gold";
      case 1:
        return "platinum";
      case 2:
        return "silver";
      case 3:
        return "bronze";
      case 4:
        return "aptel";
      default:
        return "";
    }
  };

  return (
    <>
      <div className={styles.show_participation}>
        <div className={styles.itemnumber}>
          <List
            itemLayout="vertical"
            size="large"
            loading={isLoadingList}
            pagination={{
              onChange: (page) => {
                setCurrentPage(page);
              },
              hideOnSinglePage: true,
              pageSize: 10,
              total: totalRecord,
              current: currentPage === 0 ? 1 : currentPage,
              showSizeChanger: false,
            }}
            dataSource={bTable}
            renderItem={(item, key) => (
              <div key={key} className={styles.rowitem} data-title={item?.auctionProductType} data-type={switchTagBag(item?.auctionProductTypeId)}>
                <div className={styles.msisdn_hold} data-type={switchTagBag(item?.auctionProductTypeId)}>
                  <div className={styles.tagname}>{item?.auctionProductType}</div>
                  <div className={styles.number}>
                    <h2>{item?.auctionTitle}</h2>
                    <span>{item?.bundle?.bundleName}</span>
                  </div>
                </div>
                <div className={styles.startPrice}>
                  <span>قیمت شروع</span>
                  <div className={styles.price}>
                    <span dir="ltr">{complexDigitToman(item?.startPrice)}</span> تومان
                  </div>
                </div>
                <div className={styles.prefer}>
                  <span>بالاترین پیشنهاد</span>
                  <div className={styles.price}>
                    <span dir="ltr">{complexDigitToman(item?.maxBid)}</span> تومان
                  </div>
                </div>
                <div className={styles.prefer_your_self}>
                  <span>قیمت پیشنهادی شما</span>
                  <div className={styles.price}>
                    <span dir="ltr">{complexDigitToman(item?.userBid)}</span> تومان
                  </div>
                </div>
                <div className={styles.timer}></div>
                <div className={styles.action}>
                  <Holder_Button className={`holder-button ${styles.holdbtn}`}>
                    <Button
                      className={`btn-normal ${styles.btnNormal}`}
                      onClick={(e) => nav(_adr.Root + _adr.Landing.Index + _adr.Landing.Details + `?id=${item?.auctionProductId}`)}
                    >
                      جزئیات
                    </Button>
                  </Holder_Button>
                </div>
              </div>
            )}
          />
        </div>
      </div>
    </>
  );
};

export default Participation;
